import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHatBunny: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconHatBunny"><Path d="M13 9.99976H18C18.5 8.99976 18 7.49976 18 7.49976L22.6517 7.86729C22.5682 7.74795 22.4852 7.62852 22.4024 7.50922C21.1801 5.74887 19.6447 3.57991 17.4966 2.91902C13.5483 1.70424 13.0654 7.49745 13 9.99976Z" fill="currentColor"/><Path d="M2 10.9997V12.9997H4V21.9997H20V12.9997H22V10.9997H2Z" fill="currentColor"/><Path d="M6 9.99976H11C10.6998 6.14549 9.53987 3.0292 6.95801 0.208984C5.57982 3.33777 5 5.99976 6 9.99976Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHatBunny;
